export default "__VITE_ASSET__567c959d__"